import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/masham.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>Die philophischen schriften von Gottfried Wilheim Leibniz, vol. III</var><br />
		C. I. Gerhardt (ed)<br />
		pp 336-337<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: December 1703<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (15k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Damaris Masham (December 1703)</title>
            <meta name="description" content="An English translation of a LETTER TO DAMARIS MASHAM by Gottfried Wilhelm Leibniz, from December 1703" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO DAMARIS MASHAM</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>G III p336</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I have learned that you intended to give me a copy of the <var>Intellectual System</var> by the late Mr Cudworth:<a name="1" href="#note1"><sup>1</sup></a> there is no other honour to which I could be more sensitive, with regard to the person that gave it to me and to the present itself. The first time I saw this book was in Rome, where Mr Auzout, a French mathematician of great reputation,<a name="2" href="#note2"><sup>2</sup></a> bought it, and I was delighted to see the most wonderful thoughts of the wise men of antiquity placed in their day, and accompanied by solid reflections: in a word, a lot of erudition, and a similar amount of wisdom, joined together.<a name="3" href="#note3"><sup>3</sup></a> The matter also interested me greatly, for I have had much thought on this subject, and I lay claim to having discovered a new land in this intelligible world, and thus of having increased a little this great system that your father left us, Madam, after having made it pass through the best hands of the ancients and the moderns, and enriched by his. My addition consists, among other things, in a small system of pre-established harmony between substances, of which Mr Bayle amply speaks in the two editions of his wonderful <var>Dictionary</var>, article 'Rorarius', but most amply in the second edition, where he nevertheless adds worthy new objections to be resolved. And I sent him my response, not yet published, that gave him a better introduction to the roots of my sentiment, as he recognized in the letter that he wrote to me about it. It appears, at least to this celebrated author, in the place that I have mentioned, that no-one has ever yet pushed so far the idea that one can have of the grandeur of the divine perfections and of the beauty of his work.<a name="4" href="#note4"><sup>4</sup></a> I would certainly not dare to enter so far into these matters when I have the honour of writing to a lady, if I did not know how deep the penetration goes of English ladies, of which I have seen a [<b>G III p337</b>] sample in the work of the late Countess of Conway,<a name="5" href="#note5"><sup>5</sup></a> to say nothing of others. But I must I not abuse your graces, and it is time to emphasise that I am with respect and gratitude etc.
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> Ralph Cudworth, <var>The True Intellectual System of the Universe</var> (London, 1678). Masham was Cudworth's daughter.<br />
                <a name="note2" href="#2">2.</a> Adrien Auzout (1622-1691). French mathematician and astronomer who lived in Rome for much of the last 20 years of his life.<br />
                <a name="note3" href="#3">3.</a> Leibniz studied Cudworth's book in the Spring or Summer of 1689, when in Rome, and made reasonably extensive notes on it (see A VI 4, pp1943-55).<br />
                <a name="note4" href="#4">4.</a> Bayle says of Leibniz's pre-established harmony: 'there is nothing else we can imagine that gives so exalted an idea of the intelligence and power of the Author of all things. This, added to the advantage of setting aside all notions of miraculous conduct, would make me prefer this theory to that of the Cartesians, if I could conceive some possibility in the way of &quot;pre-established harmony.&quot;' Pierre Bayle, <var>Historical and Critical Dictionary</var>, trans. and ed. Richard H. Popkin (Hackett: Indianapolis, 1991), art 'Rorarius', note L, p245.<br />
                <a name="note5" href="#5">5.</a> Anne Conway (1631-1679). Leibniz had read her book <var>The Principles of the Most Ancient and Modern Philosophy</var>, which was written in the 1670s.<br /><br /><br />
                &#169; Lloyd Strickland 2004
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
